import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {pageHeader,pageClass,formBtn1,formBtn2,ExcelBtn,pdfBtn,} from "../Components/Utils/CustomClasses";
import { DatePicker, Space } from "antd";
import Select from "react-select";
import Table from "../Components/Table/Table";
import { StaticUserAPI, UserReportAPI } from "../API/Api";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import ButtonLoader from "../Components/Loader/ButtonLoader";
import { toast } from "react-toastify";
import { downloadCSV, downloadTablePDF } from "../Components/Utils/CommonFuntion";
import BarLoader from "../Components/Loader/BarLoader";

export default function UserReport() {
  const { register } = useForm();
  const { control, handleSubmit, reset, watch } = useForm();
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const [UserReport, setUserReport] = useState([]);
  const [ariaFocusMessage, setAriaFocusMessage] = useState("");
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const [loader, setLoader] = useState(false);
  const [lodingSpinner, setLodingSpinner] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [AssignUsers, setAssignUsers] = useState([]);
  const { RangePicker } = DatePicker;
  const User = watch("user");
  const rangeDate = watch("rangeDate");

  useEffect(() => {
    setIsApplyDisabled(!(User || rangeDate));
  }, [User, rangeDate]);

  const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
        value: user?._id,
        label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
      }))
      : [{ value: "", label: "No data found" }];

  const fetchUsers = async () => {
    try {
      let response = await StaticUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        company: UserDetails?.role?.roleName === "SuperAdmin" ? "" : UserDetails?.company?._id,
      });
      setAssignUsers(response?.data?.filteredData);
    } catch (err) {
      console.log("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchUserReport({
      company: UserDetails?.role?.roleName === "SuperAdmin" ? "" : UserDetails?.company?._id,
      userId: UserDetails?._id,
      startDate: "",
      endDate: "",
    });
  }, []);

  const fetchUserReport = async (data) => {
    setLodingSpinner(true);
    try {
      const response = await UserReportAPI(data);
      if (response?.status === 200) {
        setUserReport(response?.data?.data?.Counts || []);
      } else {
        setUserReport([]);
        toast.error(response?.data?.error);
      }
    } catch (err) {
      console.error("Error in catch:", err);
    }finally {
      setLoader(false);
      setLodingSpinner(false);
    }
  };

  const onFocus = ({ focused, isDisabled }) => {
    const msg = `You are currently focused on option ${focused.label}${
      isDisabled ? ", disabled" : ""
      }`;
    setAriaFocusMessage(msg);
    return msg;
  };

  const onMenuOpen = () => setIsMenuOpen(true);
  const onMenuClose = () => setIsMenuOpen(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: "5px 10px",
      border: "2px solid rgba(228, 228, 231, 0.7)",
      borderRadius: "6px",
      outline: "none",
      caretColor: "#ef4444",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      borderColor: state.isFocused ? "#007BFF" : "rgba(228, 228, 231, 0.7)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 99999,
      position: "absolute",
    }),
  };

  const tableColumns = [
    {
      field: "user",
      header: "User",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.user === "Total"
            ? row?.user
            : row?.user?.first_name && row?.user?.last_name
              ? `${row?.user?.first_name} ${row?.user?.last_name} - ${row?.user?.roleName}`
              : "----"}
        </h6>
      ),
    },
    {
      field: "Pending",
      header: "Pending",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.Pending || "---"}
        </h6>
      ),
    },
    {
      field: "DealDone",
      header: "DealDone",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.DealDone ? row?.DealDone : "--"}
        </h6>
      ),
    },
    {
      field: "Rejected",
      header: "Rejected",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.Rejected || "--"}
        </h6>
      ),
    },
    {
      field: "CallBack",
      header: "CallBack",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.CallBack || "--"}
        </h6>
      ),
    },
    {
      field: "FollowUp",
      header: "FollowUp",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.FollowUp || "--"}
        </h6>
      ),
    },
    {
      field: "NotReachable",
      header: "NotReachable",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.NotReachable || "--"}
        </h6>
      ),
    },
    {
      field: "Ringing",
      header: "Ringing",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.Ringing || "--"}
        </h6>
      ),
    },
    {
      field: "SwitchedOff",
      header: "Switched Off",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.SwitchedOff || "--"}
        </h6>
      ),
    },
    {
      field: "InvalidNumber",
      header: "Invalid Number",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.InvalidNumber || "--"}
        </h6>
      ),
    },
    {
      field: "Prospect",
      header: "Prospect",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.Prospect || "--"}
        </h6>
      ),
    },
    {
      field: "ECP",
      header: "ECP",
      style: true,
      body: (row) => (
        <h6 className={`${row?.user === "Total" ? "font-weight-bold" : ""}`}>
          {row?.ECP || "--"}
        </h6>
      ),
    },
    {
      field: "totalCount",
      header: "Total Count",
      style: true,
      body: (row) => (
        <h6 className="font-weight-bold">{row?.totalCount || "---"}</h6>
      ),
    },
  ];
  const allowedFields = Object.keys(UserReport?.[0] || {}).filter(
    (key) => key !== "user"
  );

  let filteredColumns = tableColumns;

  if (allowedFields.length > 0) {
    filteredColumns = tableColumns.filter((col) => {
      return (
        col.field === "user" ||
        col.field === "Pending" ||
        col.field === "DealDone" ||
        col.field === "Rejected" ||
        col.field === "totalCount" ||
        allowedFields.includes(col.field)
      );
    });
  }

  const onSubmit = (data) => {
    setLoader(true);
    let startDateFormatted = "";
    let endDateFormatted = "";
    if (data?.rangeDate != undefined && data?.rangeDate?.length != 0) {
      const startDate = `${data?.rangeDate[0].$D}-${
        data?.rangeDate[0].$M + 1
        }-${data?.rangeDate[0].$y}`;
      const endDate = `${data?.rangeDate[1].$D}-${data?.rangeDate[1].$M + 1}-${
        data?.rangeDate[1].$y
        }`;
      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    const UpdatedData = {
      userId: data?.user?.value,
      company: UserDetails?.company?._id,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
    };
    fetchUserReport(UpdatedData);
  };

  const onClear = () => {
    reset({
      user: null, // Reset select field
      rangeDate: null, // Reset date range picker
    });
    fetchUserReport({
      userId: UserDetails?._id,
      company: UserDetails?.company?._id,
      startDate: "",
      endDate: "",
    });
  };
  const submitPdfExcel = (download) => {
    const Header = filteredColumns.map((col) =>
      col.field === "user" ? "Employee_Names" : col.field
    );

    const formattedReportData = UserReport?.map((report) => ({
      ...report,
      Employee_Names:
        report?.user === "Total"
          ? "Total"
          : report?.user?.first_name && report?.user?.last_name
            ? `${report?.user?.first_name} ${report?.user?.last_name} - ${report?.user?.roleName}`
            : "----",
    }));
    download === "Csv" ? downloadCSV(Header, formattedReportData, "Report") : downloadTablePDF(Header, formattedReportData, "Report");
  };

  return (
    <div className={`${pageClass}`}>
      <div className="bg-[#FFFFFF] p-10 rounded-xl">
        <div className="flex items-center justify-between">
          <h1 className={`${pageHeader} text-xl md:text-2xl lg:text-3xl`}>
            Employee Report
          </h1>
          <div className="flex sm:mb-0 sm:mr-2 mt-2 justify-end">
            <button className={ExcelBtn} onClick={() => submitPdfExcel("Csv")}>
              Excel
            </button>
            <button className={pdfBtn} onClick={() => submitPdfExcel("Pdf")}>
              PDF
            </button>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
          <div className="flex flex-col lg:flex-row gap-3">
            {/* FILTERS DIV */}
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
              <div>
                <Controller
                  name="user"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      styles={customStyles}
                      aria-labelledby="aria-label"
                      ariaLiveMessages={{ onFocus }}
                      inputId="aria-example-input"
                      onMenuOpen={onMenuOpen}
                      onMenuClose={onMenuClose}
                      options={assignToOptions}
                      placeholder="Select User"
                      maxMenuHeight={220}
                    />
                  )}
                />
              </div>

              <div className="w-full">
                <Space direction="vertical" size={12} className="w-full">
                  <Controller
                    name="rangeDate"
                    control={control}
                    render={({ field }) => (
                      <RangePicker
                        {...field}
                        disabled={isApplyDisabled}
                        className={`w-full h-[48px] rounded-lg border border-[#DFDFDF] bg-[#F9FAFB] px-3 shadow-none hover:shadow-none focus:shadow-none ${
                          isApplyDisabled ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                      />
                    )}
                  />
                </Space>
              </div>
            </div>

            {/* BUTTON DIV */}
            <div className="flex gap-2 justify-end flex-shrink-0 items-center">
              {loader ? (
                <ButtonLoader />
              ) : (
                <button
                  type="submit"
                  className={`${formBtn1} ${
                    isApplyDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "bg-base-color"
                    }`}
                  disabled={isApplyDisabled}
                >
                  Apply
                </button>
              )}

              <button
                type="button"
                onClick={onClear}
                className={`${formBtn2} ${
                  isApplyDisabled
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                  }`}
                disabled={isApplyDisabled}
              >
                Clear
              </button>
            </div>
          </div>
        </form>
        <div className="min-w-[361px] sm:min-w-[400px] p-0 sm:p-[3.5rem] rounded-lg">
          <div className="flex flex-col sm:flex-row">
            <div className="w-full">
              <div className="mt-4">

                {lodingSpinner ? (
                  <BarLoader />
                ) : (
                  <Table
                    columns={filteredColumns}
                    data={UserReport}
                    paginatorCheck={false}
                    register={register}
                  />
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
